import { SmlMonitor } from 'smr-performance-monitor';
// utils
import { API, isDev } from '../../config';
// web-add 请求前缀
const baseUrl = '/capi/v2/report/web-add';
const reportPath = isDev ? baseUrl : API.apiHost + baseUrl;
const smlMonitor = new SmlMonitor({
  reportPath,
});

// 标记名称
enum markName {
  // app 初始化
  appRelaunchMark = 'appRelaunchMark',
  // 切换路由
  changeRouterMark = 'changeRouterMark',
}

// 结束标记类型
enum endMarkType {
  // app 初始化
  appRelaunch = 'appRelaunch',
  // 切换路由
  changeRouter = 'changeRouter',
}

export { endMarkType, markName, smlMonitor };
